<script lang="ts">
    export let value = null;
    export let label;
    export let name;
    export let placeholder;
    export let error = null;
</script>

<div class="field">
    <label class="label" for={name}>{label}</label>
    <div class="control">
        <input bind:value class="input" id={name} name={name} placeholder={placeholder} {...$$restProps}>
    </div>
    {#if error}
        <p class="help is-danger">{error}</p>
    {/if}
</div>